import { formDefinition } from '@social-solutions/ssg-forms-processing';

/**
 * Form definition for the unsubscription confirmation screen.
 * A response is required for submission to occur.
 */

export const confirmOptOutElement = {
  id: 'opt-out-confirm-element',
  label: 'Are you sure you wish to remove this email address from further direct messages?',
  ariaLabel: "Are you sure you wish to remove this email address from further direct messages?",
  type: formDefinition.elementTypes.radio,
  options: [
    {
      value: "0",
      label: "No"
    },
    {
      value: "1",
      label: "Yes"
    }
  ],
  isRequired: true,
};

const optOutConfirmFormDef = {
  id: 'opt-out-confirm-form',
  name: null,
  elements: [confirmOptOutElement]
}

export default optOutConfirmFormDef;



// WEBPACK FOOTER //
// src/acct/opt-out/opt-out-confirm-form-definition.js